export default {
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~ESPANOL~': 'Español',
    '~INGLES~': 'Inglés',
    '~PORTUGUES~': 'Portugués',
    '~ITALIANO~': 'Italiano',
    '~FRANCES~': 'Francés',
    '~IDIOMA~': 'Idioma',
    '~IDIOMA2~': 'Idioma de Reconocimiento',
    '~MENU~': 'Menú',
    '~USUARIOS~': 'Usuarios',
    '~EDITAR~': 'Editar',
    '~DUPLICAR~': 'Duplicar',
    '~REFRESCAR~': 'Refrescar',
    '~DESACTIVAR~': 'Desactivar',
    '~CARGANDO~': 'Cargando',
    '~TOTALES~': 'totales',
    '~ACTIVAR~': 'Activar',
    '~AYUDA~': 'Ayuda',
    '~AYUDA_ACTIVADA~': 'Ayudas Activadas',
    '~AYUDA_DESACTIVADA~': 'Ayudas Inactivas',
    '~ACTIVADAS~': 'Mensajes de ayuda activados',
    '~DESACTIVADAS~': 'Mensajes de ayuda desactivados',
    '~CONFIRMAR_AYUDA~': '¿Desea desactivar los mensajes de ayuda?',
    '~ACEPTAR~': 'Aceptar',
    '~CONECTANDO~': 'Conectando',
    '~OPCIONES~': 'Opciones',
    '~ELIMINAR~': 'Eliminar',
    '~REMOVER~': 'Remover',
    '~CANCELAR~': 'Cancelar',
    '~OMITIR~': 'Omitir',
    '~EXPANDIR~': 'Expandir',
    '~AGREGAR~': 'Agregar',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuración',
    '~HOY~': 'Hoy',
    '~SEMANA~': 'Semana',
    '~PERSONALIZAR~': 'Personalizar',
    '~ESTUDIANTE~': 'Estudiante',
    '~MASCULINO~': 'Masculino',
    '~FEMENINO~': 'Femenino',
    '~VOLVER~': 'Volver',
    '~SIGUIENTE~': 'Siguiente',
    '~ANTERIOR~': 'Anterior',
    '~GUARDAR~': 'Guardar',
    '~CERRAR~': 'Cerrar',
    '~VALIDA_POR~': 'Válida por',
    '~FAMILIA~': 'Familias',
    '~AUTORIZADO~': 'Autorizado',
    '~AMIGOS~': 'Amigos',
    '~PERSONAS~': 'Personas',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Vehículos',
    '~RETIRADAS_AUTORIZADO~': 'Retiradas por Autorizado',
    '~HORAS_RETIRADA~': 'Horas de Retirada',
    '~CAMBIAR_CLAVE~': 'Cambiar Clave',
    '~EDITAR_PERFIL~': 'Editar Perfil',
    '~HOME~': 'Inicio',
    '~COFIGURACION~': 'Configuración',
    '~MENU_PRINCIPAL~': 'Menú Principal',
    '~FECHA~': 'Fecha',
    '~ALUMNOS~': 'Alumnos',
    '~INFORMACION~': 'Información',
    '~FOTO_PERFIL~': 'Foto de Perfil',
    '~FOTO_VEHICULO~': 'Foto del Vehículo',
    '~TOMAR_FOTO~': 'Tomar Foto',
    '~SUBIR_ARCHIVO~': 'Subir Archivo',
    '~REGISTROS~': 'Registros',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Detalles',
    '~BUSCADOR~': 'Buscar',
    '~SALIR~': 'Salir',
    '~TIPO~': 'Tipo',
    '~CONTINUAR~': 'Continuar',
    '~CONFIRMAR~': 'Confirmar',
    '~FINALIZAR~': 'Finalizar',
    '~FINALIZADO~': 'Campaña guardada',
    '~ALERTA~': '¡Alerta!',
    '~TITULO~': 'Titulo',
    '~VOZ~': 'Voz',
    '~NOTA~': 'Nota',
    '~ACCION~': 'Acción',
    '~ACCIONES~': 'Acciones',
    '~FILAS~': 'Filas',
    '~DE~': 'de',
    '~A~': 'a',
    '~TEXTO~': 'Texto',
    '~NUMERO~': 'Número',
    '~NEXT_STEP~': 'Siguente Paso',
    '~CONFIRMAR_BORRAR~': '¿Está seguro que desea eliminar?',
    '~CONFIRMAR_REMOVER~': '¿Está seguro que desea remover?',
    '~CONFIRMAR_PARAR~': '¿Está seguro que desea detener la campaña?',
    '~MENSAJE_REFRESCAR~': '¡Advertencia! La información en esta tabla no está actualizada, <br /> por favor haga click en \'Refrescar\'',
    relation: {
      '~NOMBRE~': 'Relación',
      options: {
        '~PADRE~': 'Padre',
        '~HIJO~': 'Hijo',
        '~RELATIVO~': 'Familiar',
        '~EMPLEADO~': 'Empleado'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'EL correo electronico ya está tomado'
  },
  login: {
    '~TITULO~': 'Autenticación',
    '~USUARIO~': 'Usuario',
    '~CLAVE~': 'Clave',
    '~NUEVA~': 'Nueva Clave',
    '~CORREO~': 'Correo',
    '~ENTRAR~': 'Entrar',
    '~OLVIDO~': '¿Has olvidado la contraseña?',
    '~RECORDARME~': 'Recordarme',
    '~CONTACTO~': 'Contactar Webmaster',
    '~RECUPERAR~': 'Recuperar Clave',
    '~MENSAJE~': 'Hemos enviado un correo con las instrucciones de recuperación',
    '~RECUPERACION_OK~': 'Su contraseña ha sido modificada exitosamente',
    '~ENVIAR~': 'Enviar',
    '~VOLVER~': 'Volver',
    '~RESETEAR~': 'Resetear Clave',
    '~VERIFICAR~': 'Verificar Clave',
    '~BIENVENIDO~': 'Bienvenido al Sistema IP-COM',
    '~NO_AUTORIZADO~': '¡Disculpe! el correo o la clave son incorrectos',
    '~NO_AUTENTICADO~': '¡Disculpe! Usted no se encuentra autenticado',
    '~EXITOSO~': 'Inicio de sesión exitoso',
    '~NO_USUARIO~': '¡Error! Este usuario no se encuentra'
  },
  menu: {
    '~INICIO~': 'Inicio',
    '~TABLERO~': 'Tablero',
    '~CAMPAGNA~': 'Campañas',
    '~CAMPAGNA_ABIERTA~': 'Campañas Abiertas',
    '~BASE_DATOS~': 'Bases de Datos',
    '~ORGANIZACION~': 'Organizaciones',
    '~USUARIOS~': 'Usuarios',
    '~REPORTES~': 'Reportes',
    '~CONFIGURACION~': 'Configuración'
  },
  campaign: {
    '~CAMPAGNA~': 'Campaña',
    '~IDIOMA~': 'Idioma',
    '~CAMPAGNA_ABIERTA~': 'Modo Campaña Abierta',
    '~EDITAR~': 'Editar Campaña',
    '~CERRAR~': 'Cerrar Campaña',
    '~INSERTAR~': 'Nueva Campaña',
    '~NOMBRE~': 'Nombre de Campaña',
    '~SUSCRIPTORES~': 'BD Suscriptores',
    '~PASO~': 'Paso',
    '~ESTADO~': 'Estado',
    '~ARBOL~': 'Arbol de Navegación',
    '~TRANSICION~': 'Transición',
    '~DIGITOS~': 'Dígitos',
    '~VARIABLE_NOMBRE~': 'Nombre Variable',
    '~TIEMPO~': 'Tiempo',
    '~COMANDO_VOZ~': 'Voz',
    '~BASE_DATOS~': 'Base de Datos',
    '~LLAMADAS~': 'Llamadas Concurrentes',
    '~INTERACCION~': 'Interacción',
    '~TASA_CONTACTO~': 'Tasa de contacto',
    '~PREFIJO~': 'Prefijo de Marcado',
    '~REJECT_CODES~': 'Códigos de Rechazo RDSI',
    '~GRUPOS_RUTAS~': 'Grupos de Rutas',
    '~IDENTIFICADOR~': 'ID de Llamada',
    '~ID_CLIENTE~': 'ID Cliente',
    '~TIEMPO_ESPERA~': 'Tiempo de Espera',
    '~TIEMPO_DIGITOS~': 'Tiempo de Espera de Dígito',
    '~TIEMPO_REINTENTO~': 'Tiempo de Reintento',
    '~MAQUINA_RESPUESTA~': 'Detección de contestador automático',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Detecta automáticamente contestadores (AMD) y buzones de voz.',
    '~MAQUINA_COLGAR~': 'Colgar al detectar correo de voz',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Finaliza la llamada cuando detecta un buzón de voz.',
    '~TITULO~': 'Título',
    '~TODAS~': 'Todas',
    '~TTS_MENSAJE~': 'Mensaje TTS',
    '~TTS_MENSAJE2~': 'Mensaje TTS Previo',
    '~PREFIJO_ARCHIVO~': 'Prefijo de Archivo',
    '~MAXIMA_LONGITUD~': 'Máxima Logitud',
    '~REPETIR~': 'Repetir',
    '~FINAL~': '# Al Final',
    '~IMPORTAR~': 'Importar Contactos',
    '~IMPORTAR_CVS~': 'Importar nuevos registros',
    '~IMPORTAR_DESC~': 'Ahora emparejemos las columnas del archivo cargado con su lista de Suscriptores',
    '~OMITIR_CABECERAS~': 'Sin Cabeceras',
    '~NUEVA_COLUMNA~': 'Nombre Nuevo',
    '~INTENTOS_MAXIMOS~': 'Máximo de Intentos',
    '~PROXIMO_REINTENTO~': 'PRI',
    '~INTENTOS_ALCANZADOS~': 'Número máximo de intentos alcanzado',
    '~LLAMADAS_ALCANZADOS~': 'Número máximo de llamadas alcanzado',
    '~INTENTOS_MAX~': 'Máx. Intentos',
    '~MAXIMO_ALCANZADO~': 'Limite máximo alcanzado',
    '~CANALES_MAXIMOS~': 'Canales Máximos',
    '~ZONA_HORARIA~': 'Zona Horaria',
    '~COLGAR_NO_RESP~': 'Colgar si no hay respuesta',
    '~EXTENSION~': 'Extensión',
    '~MINIMO_HORA~': 'Hora Mínima',
    '~MAXIMO_HORA~': 'Hora Máxima',
    '~SELECCIONAR_FECHA~': 'Seleccionar Fecha',
    '~FECHA_COMIENZO~': 'Fecha Inicio',
    '~FECHA_FINAL~': 'Fecha Final',
    '~FECHA_ERROR~': 'La fecha de inicio debe menor que la fecha final.',
    '~FECHA_CREACION~': 'Fecha de Creación',
    '~ACTIVAS~': 'Campañas Activas',
    '~ULTIMAS~': 'Últimas Campañas',
    '~BASES_MONITOREADAS~': 'Bases Monitoreadas',
    '~NUMEROS~': 'Numeros',
    '~EN_COLA~': 'En Cola',
    '~MARCADO~': 'Marcado',
    '~CONTACTO~': 'Contacto',
    '~VER~': 'Ver',
    '~ACTIVA~': 'Activo / Máx',
    '~SILENCIO~': 'Silencio',
    '~REPETICIONES~': 'Número de Repeticiones',
    '~AUDIO_INVALIDO~': 'Audio de Reintento',
    '~FRASE~': 'Frase',
    '~VARIABLE~': 'Variable',
    '~FORMULA~': 'Formula',
    '~GENERACION_TTS~': 'Generación de TTS',
    '~GENERAR_AUDIOS~': 'Sintetizar Audios',
    '~PROBAR_AUDIO~': 'Probar TTS',
    '~DESCARGAR_TTS~': 'Descargar TTS',
    '~ARCHIVAR~': 'Archivar',
    '~OPERADOR~': 'Operador',
    '~AYUDA_VARCOMP~': 'Sintaxis códigos avanzados',
    '~GUARDANDO~': 'Guardando campaña',
    '~VOICES2_NOT_FOUND~': 'No existen voces para el idioma seleccionado.',
    '~ACTIVE_CHANNELS~': 'Canales Activos',
    subscriber: {
      '~BD_CREADA~': 'La base de datos fue creada con éxito'
    },
    sayas: {
      '~NOMBRE~': 'Decir como',
      options: {
        '~CARACTERES~': 'Caracteres',
        '~NUMERO~': 'Número',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Dígitos',
        '~FECHA~': 'Fecha'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'ID de llamada',
      '~TELEFONO~': 'Número telefónico como ID de llamada',
      '~CLIENTE~': 'ID de cliente como ID de llamada',
      '~SUSCRIPTOR~': 'ID de Suscriptor como ID de llamada'
    },
    '~NO_PAREJA~': 'columna sin emparejar',
    '~NO_CAMPANA~': 'No existen campañas registradas',
    '~NO_ACTIVAS~': 'No existen campañas activas',
    '~SIN_RESULTADOS~': 'No se encontraron campañas con ese criterio',
    '~BUSCAR_CAMPANA~': 'Buscar por nombre o ID...',
    '~NO_RESULTADO~': 'No hubo resultado en búsqueda',
    formula: {
      '~IGUAL~': 'Igual',
      '~MAYOR~': 'Mayor que',
      '~MENOR~': 'Menor que',
      '~MAYOR_IGUAL~': 'Mayor o igual',
      '~MENOR_IGUAL~': 'Menor o igual',
      '~DISTINTO~': 'Distinto',
      '~REGULAR~': 'Regex',
      '~DEFAULT~': 'Defecto',
      '~DEFAULT_NAME~': 'Acción por defecto'
    }
  },
  organization: {
    '~TITULO~': 'Organización',
    '~TITULO_PROGRAMA~': 'Título del Software',
    '~LOGO_PERSONALIZADO~': 'Logo Personalizado',
    '~EDITAR~': 'Editar Organización',
    '~INSERTAR~': 'Nueva Organización',
    '~NOMBRE~': 'Nombre de la Organización',
    '~TELEFONO~': 'Teléfono',
    '~NOMBRE_COMPLETO~': 'Nombre Completo',
    '~SELECCIONADO~': 'Selección',
    '~NO_ORGANIZATION~': 'No existen organizaciones registradas',
    '~IMAGEN_ERROR~': 'EL limite del tamaño ha sido excedido!',
    '~IMAGEN_MENSAJE~': 'Sólo formatos .png y .jpg y tamaño de máximo 5Mg',
    '~IMAGEN_TAMANO~': 'Medidas 264px/120px',
    '~PAÍS~': 'País',
    '~CPS_MÁXIMO~': 'CPS máximo',
    '~PROPIA~': 'Propia',
    '~TELEFONÍA~': 'Telefonía',
    '~Añadir_CPS~': 'Añadir CPS',
    '~CPS_MÁXIMO_ERROR~': 'El CPS del país no puede exceder los CPS de la organización padre en ese país. CPS Máximo: {cps}. País: {country}'
  },
  dialer: {
    '~NOMBRE~': 'Marcadores',
    '~CAPACIDAD~': 'Capacidad',
    '~ACTIVOS~': 'Activos',
    '~NO_MARCADORES~': 'No hay marcadores activos'
  },
  database: {
    '~TITULO~': 'Base de Datos',
    '~EDITAR~': 'Editar Base de Datos',
    '~INSERTAR~': 'Nueva Base de Datos',
    '~NOMBRE~': 'Nombre de Base de Datos',
    '~CREADA~': 'Creada',
    '~ESTADO~': 'Estado',
    '~COLUMNAS~': 'Columnas',
    '~REGISTROS_DE~': 'registros de',
    '~SUSCRIPTORES~': 'Susc.',
    '~BORRAR_SUBS~': 'Eliminar suscriptores que no se encuentre en este nuevo archivo',
    '~EDITAR_SUBS~': 'Actualizar variables en suscriptores existentes',
    '~SUSCRIPTORES_FULL~': 'Suscriptores',
    '~NO_DATABASE~': 'No bases de datos registradas',
    '~NO_RESULTADO~': 'No se obtuvo resultado en la búsqueda',
    '~VARIABLE_PHONE~': 'Debe existir un campo con nombre "phone" para continuar',
    '~VALIDATE_NUMBER~': 'Validar numeración',
    '~COUNTRY~': 'País',
    '~ONLY_CALL_TO_NUMBERS~': 'Solo marcar para números',
    '~DONWLOAD_INVALID_NUMBERS~': '¿Deseas descargar el reporte de números inválidos de la base de datos?'

  },
  report: {
    '~TITULO~': 'Reportes',
    '~EDITAR~': 'Editar Reporte',
    '~INSERTAR~': 'Nueva Reporte',
    '~CREADA~': 'Creada',
    '~ESTADO~': 'Estado',
    '~INFORME_RESUMIDO~': 'Informe Resumido',
    '~INFORME_BASE~': 'Informe Base',
    '~INFORME_DURACION~': 'Informe de Duración',
    '~ENCUESTA~': 'Encuesta',
    '~CONTESTADA~': 'Contestada',
    '~RESPUESTAS~': 'Respuestas',
    '~PROMEDIO_ENCUESTA~': 'Survey Ratio',
    '~OCUPADO~': 'Ocupado',
    '~SEGUNDOS~': 'Segundos',
    '~SEGUNDOS_MIN~': 'Seg',
    '~MINUTOS~': 'Minutos',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Número Inválido',
    '~NO_REPICO~': 'No Repicó',
    '~NO_CONTESTO~': 'No Contestó',
    '~PROMEDIO_CONTESTO~': 'Porcentaje Contestadas',
    '~DETALLES_INTENTOS~': 'Detalles por Intentos',
    '~INTENTOS~': 'Intento',
    '~DISPOSICION~': 'Disposición',
    '~NUMEROS~': 'Números',
    '~CODIGO_ISDN~': 'Código ISDN',
    '~PRIMERO~': 'Priemro',
    '~ULTIMO~': 'Último',
    '~NO_REPORTE~': 'No bases de datos registradas',
    '~NO_DATA~': 'No hay suficientes datos',
    '~DESCARGAR~': 'Descargar Reportes',
    '~SUMAR_REPORTES~': 'Sumar Reportes',
    '~REPORTE_COMPLETO~': 'Reporte Completo',
    '~SUMADAS~': 'Sumadas',
    '~TITULO_SELECCION~': 'Seleccione las campañas que desea añadir al reporte'
  },
  users: {
    '~EDITAR~': 'Editar Usuario',
    '~INSERTAR~': 'Nuevo Usuario',
    '~NO_USUARIOS~': 'No existen usuarios registrados',
    '~AGREGAR~': 'Agregar Usuario',
    '~TITULO~': 'Lista de Usuarios',
    '~NOMBRE~': 'Nombre',
    '~APELLIDO~': 'Apellido',
    '~CORREO~': 'Correo',
    '~CLAVE~': 'Clave',
    '~TELEFONO~': 'Teléfono',
    '~CELULAR~': 'Celular',
    '~POSICION~': 'Posición',
    '~ID_TARJETA~': 'Tarjeta',
    '~ACTIVO~': 'Activo',
    '~INACTIVO~': 'Inactivo',
    '~ROL~': 'Roles',
    '~ORGANIZACIONES~': 'Organizaciones',
    '~ROLES_TODAS~': 'Actualizar roles en todas las orgs',
    '~ROLES_ACTUAL~': 'Actualizar roles solo para',
    '~ACTUALIZAR_ORGS~': 'Actualizar organizaciones a la cual pertenece el usuario',
    '~BUSCAR~': 'Buscar...',
    '~ETIQUETA_SELECCION~': 'Presiona enter para seleccionar'
  },
  file: {
    '~NOMBRE~': 'Nombre',
    '~NOMBRE_AMIGABLE~': 'Nombre Amigable',
    '~SUBIR~': 'Subir Archivo',
    '~ACEPTABLE~': 'Tipo de archivo aceptable: CSV',
    '~PERMANENTE~': 'Permanente',
    '~DESCARGAR~': 'Descargar Reporte'
  },
  audio: {
    '~AGREGAR~': 'Agregar Audio',
    '~BORRAR~': 'Borrar',
    '~SELECCION~': 'Seleccionar Audio',
    '~REPRODUCIR~': 'Reproducir',
    '~REPRODUCIENDO~': 'Reproduciendo',
    '~DETENER~': 'Parar',
    '~PAUSAR~': 'Pausar',
    '~CONTINUAR~': 'Continuar',
    '~VOZ~': 'Voz',
    '~NOMBRE~': 'Nombre de Audio',
    '~ARCHIVO~': 'Archivo de Audio',
    '~NO_AUDIO~': 'No hubo resultados',
    '~GUARDANDO~': 'Guardando audios'
  },
  action: {
    '~NOMBRE~': 'Acción',
    options: {
      '~COLGAR~': 'Colgar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Empezar',
      '~REPETIR~': 'Repetir'
    }
  },
  step: {
    '~NOMBRE~': 'Paso',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Reproducir',
      '~RECORD~': 'Grabar',
      '~RECORD_DIGITS~': 'Capturar Tonos',
      '~TRANSFERIR~': 'Transferir',
      '~ASR~': 'Asr',
      '~VARIABLE_WEB~': 'Variable Web',
      '~COLGAR~': 'Colgar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Empezar',
      '~REPETIR~': 'Repetir',
      '~DELAY~': 'Retraso'
    }
  },
  transition: {
    '~NOMBRE~': 'Transición',
    options: {
      '~DIGITOS~': 'Dígitos',
      '~SIGUIENTE~': 'Siguiente',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'Ninguno'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~': '<strong>¡Bienvenido a IPCOM!</strong><br /><br />Te brindamos herramientas de alta tecnología para ayudarte a tomar las mejores decisiones.<br /><br />En el siguiente tour podrás conocer la forma más fácil de utilizar nuestro sistema haciendo clic en  <strong>Siguiente</strong>',
      '~MENU~': 'Selecciona las opciones del menú de forma directa: <strong>Tablero</strong> para las campañas activas, <strong>Organizaciones</strong> que difunden las campañas, <strong>Bases de Datos</strong> de sus afiliados, generación de <strong>Campañas</strong> y <strong>Usuarios</strong> autorizados para crearlas.',
      '~USER_CARD~': 'Indica el perfil o usuario activo para usar el sistema <strong>IPCOM</strong>',
      '~SALIR~': 'Botón para cerrar sesión.',
      '~LISTA_ORG~': 'Lista de selección, úsala para cambiar la organización actual, desde la cual se generarán las campañas y configuraciones en el sistema',
      '~MENU_TABLERO~': '<strong>Tablero</strong><br /><br />Presenta las campañas activas en tiempo real, las últimas campañas procesadas, la base de datos de afiliados, y los audios TTS generados en cada campaña.',
      '~MENU_ORGANIZACION~': '<strong>Organización</strong><br /><br />Muestra las organizaciones clientes y permite registrar nuevas organizaciones, editarlas y eliminarlas.',
      '~MENU_BASEDATOS~': '<strong>Bases de Datos</strong><br /><br />Permite ver, administrar y generar bases de datos de suscriptores utilizadas al momento de crear una campaña.',
      '~MENU_CAMPANA~': '<strong>Campañas</strong><br /><br />Permite ver, crear, administrar y configurar campañas. Supervisa la hora exacta y fecha de generación de cada campaña. Revisa y descarga reportes.',
      '~MENU_USERS~': '<strong>Usuarios</strong><br /><br />Usuarios registrados y autorizados para crear, supervisar, editar y configurar campañas, bases de datos, etc, según el rol y nivel de acceso concedidos.',
      '~BARRA~': 'Barra superior, contiene la página de navegación actual y algunas herramientas.',
      '~IDIOMA~': 'Selección de idioma.',
      '~MENU_IDIOMA~': 'Opciones de lenguaje.',
      '~AYUDA~': 'Activar o desactivar ayudas visuales.',
      '~ACTIVAS~': 'En este panel se muestra los detalles y especificaciones de las campañas activas en tiempo real.',
      '~CAMPANAS~': 'En este panel se encuentran las últimas campañas, activas y/o modificadas.',
      '~SUBSCRIBERS~': 'En este panel se enumeran las bases de datos de suscriptores más recientes creadas o modificadas.',
      '~TTS_AUDIOS~': 'En este panel se muestra los archivos TTS (Tech To Speech) generados en tiempo real, utilizados por la organización en campañas activas y antiguas.',
      organization: {
        '~INTRO~': 'Vista general de las organizaciones registradas en IPCOM con sus datos configurados según la empresa; además de las opciones para agregar nuevas y editar o eliminar las ya existentes.',
        '~BUSCADOR~': 'Escribe el nombre de la organización que quieres buscar.',
        '~INSERTAR~': 'Registra nuevas organizaciones en el sistema.',
        '~TABLA~': 'Cada fila muestra el ID de la organización en el sistema y el nombre legal. También puede editar o eliminar organizaciones ya registradas.',
        '~ACCIONES~': 'Acciones para la gestión de la organización respectiva.',
        '~EDITAR~': 'Edite datos de la organización respectivamente.',
        '~ELIMINAR~': 'Eliminar la organización del sistema después de la confirmación.'
      },
      subscriber: {
        '~INTRO~': 'Selecciona una base de datos ya cargada en el sistema o agrega nuevas bases de datos para tu campaña. <br /><br />Puedes editar o eliminar el banco de datos que requieras, si es necesario.',
        '~BUSCADOR~': 'Escribe el nombre de la base de datos que quieres buscar.',
        '~INSERTAR~': 'Carga nuevas bases de datos al sistema.',
        '~TABLA~': 'Cada fila refleja el nombre de la base de datos, fecha de creación, número de suscriptores y columnas utilizadas en la campaña.',
        '~ACCIONES~': 'Acciones para la gestión de la bases de datos respectiva.',
        '~EDITAR~': 'Editar la configuración de esta base de datos.',
        '~ELIMINAR~': 'Eliminar esta base de datos luego de confirmar.',
        uploadform: {
          '~FORMULARIO~': '<strong>Formulario de Archivo</strong><br /><br /> El archivo CSV (comma-separated values) se utiliza para intercambiar datos en forma de columna de una hoja de cálculo.<br /><br /> Agregue el nombre y cargue el archivo CSV que tiene guardado en su dispositivo.',
          '~ARCHIVO~': 'Click para seleccionar el archivo CSV desde su dispositivo.',
          '~CANCELAR~': 'Cancelar y regresar a la pantalla anterior.',
          '~ENVIAR~': 'Enviar formulario e ir al paso siguiente.'
        },
        import: {
          '~FORMULARIO~': '<strong>Importar Contactos</strong><br /><br /> Antes de importar la base de datos, configure los nombres de las variables contenidas en el archivo CSV cargado anteriormente.',
          '~GRUPO~': 'Cada cuadro representa una columna del archivo CSV cargado anteriormente.',
          '~COLUMNAS~': 'Este cuadro muestra el nombre de la columna, parte de su contenido y opciones de configuración para editar u omitir la variable.',
          '~EDITAR~': 'Haga clic si desea modificar el nombre de la columna.',
          '~OMITIR~': 'Haga clic si desea Omitir esta columna de la base de datos.',
          '~CABECERAS~': 'Permite descartar la primera fila o cabecera del archivo CSV cargado anteriormente.',
          '~CANCELAR~': 'Cancelar e ir al menú anterior.',
          '~GUARDAR~': 'Guardar todos los cambios y generar la nueva Base de Datos de suscriptores.'
        }
      },
      campaign: {
        '~INTRO~': 'Revisa, administra y configura antiguas y nuevas campañas. <br /><br />Supervisa la hora exacta y fecha de generación de las campañas. Revisa y descarga reportes.',
        '~BUSCADOR~': 'Escribe el nombre de la campaña que quieres buscar.',
        '~INSERTAR~': 'Configura una nueva campaña desde cero.',
        '~TABLA~': 'Cada  fila presenta el nombre de una campaña en el sistema, su status, fecha y hora de creación y acciones para su configuración.',
        '~ACCIONES~': 'Acciones para la gestión de la campaña respectiva.',
        '~EDITAR~': 'Edita todos los datos y configuración de la campaña.',
        '~COPIAR~': 'Crea nuevas campañas utilizando clonando el contenido de ésta campaña.',
        '~REPORTES~': 'Indaga datos, estadísticas e información relevante de la campaña.',
        '~DESCARGAS~': 'Descarga el reporte de la campaña en un archivo CSV.',
        '~ARCHIVAR~': 'Archivar el reporte de la campaña.',
        '~CPS_MÁXIMO_ERROR~': 'El valor asignado a los CPS excede el máximo establecido dentro de la organización. CPS Máximo: {cps}',
        steps: {
          '~COFIGURACION~': '<strong>Configuración</strong><br /><br />Escribe correctamente los datos solicitados en cada una de las casillas de registro de la configuración. <br /><br />Estos datos determinan el valor de las variables en la campaña que se va a agregar.',
          '~BASEDATOS~': 'Selecciona una base de datos ya cargada en el sistema o agrega nuevas bases de datos para tu campaña. <br /><br />Puedes editar o eliminar el banco de datos que requieras, si es necesario.',
          '~DIAPLAN~': 'Crea la Campaña que deseas mediante un sistema de pasos.<br /><br /> El Dialplan se organiza por pasos y transiciones.',
          '~ENVIAR~': 'Antes de enviar, verifica que los datos, archivos, audios y solicitudes realizadas han sido cargadaos correctamente.',
          '~NAVEGADOR~': 'Navegue a través de esta barra (breadcrumbs), para encontrar la forma de regresar al paso anterior.',
          '~SELECTOR~': 'Seleccione de esta lista el tipo de paso que le permita configurar correctamente el Dialplan.',
          '~ACTUAL~': 'En esta área se configura el paso actual.<br /><br /> Complete los datos correctamente según el tipo de paso seleccionado para el Dialplan.',
          '~TRANSICION~': 'La transición permite conectar nuevos pasos en la campaña según la configuración que necesite',
          '~ARBOL~': 'Le permite conocer los pasos utilizados durante la configuración la cada campaña.<br /><br /> Puede seleccionar cualquier paso que desee editar.',
          '~PASO_ACTUAL~': 'El resaltado en azul significa el paso que se está editando actualmente.',
          '~PANEL_CONFIG~': 'Resumen de los datos de configuración en el paso 1.',
          '~PANEL_DATABASE~': 'Información de la base de datos de suscriptores que se usará en la campaña.',
          '~PANEL_DIALPLAN~': 'Árbol de pasos que muestra el plan de marcado previamente configurado.',
          '~ENVIAR_FINAL~': 'Click aquí en Enviar, una vez este de acuerdo con la informacíon aquí mostrada.',
          '~SINTETIZAR~': 'En caso de que dentro de su plan de marcado existan audios que se tienen que generar, deberá primero hacer click aquí para proceder a generarlos.'
        }
      },
      user: {
        '~INTRO~': 'Conozca los principales datos de los usuarios registrados y autorizados por su organización para administrar y configurar el sistema.',
        '~BUSCADOR~': 'Explora usuarios por nombre, apellido, número telefónico o correo electrónico.',
        '~INSERTAR~': 'Registrar un nuevo usuario en el sistema.',
        '~TABLA~': 'Cada fila muestra nombres y apellidos del usuario, número de teléfono, email, rol en el sistema, número de tarjeta y status de actividad.',
        '~ACCIONES~': 'Acciones para la gestión de un usuario respectivo.',
        '~ACIVAR~': 'Activar y desactivar usuario.',
        '~EDITAR~': 'Edite datos de usuario respectivamente.',
        '~ELIMINAR~': 'Eliminar usuario del sistema después de la confirmación.'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es.js